export const rawTestPayload = {
  commands: [
    "\x1B\x40",        // Reset
    "\x1B\x74\x10",    // CP1252
    "\x1B\x61\x01",    // Centrado
    "\x1B\x21\x30",    // Doble ancho + negrita
    "CODENOVA POS\n",
    "\x1B\x21\x00",
    "------------------------------\n",
    "Prueba de impresión directa (React)\n",
    "¡Gracias por su compra!\n",
    "Café, azúcar, piña, jalapeño, año, niño, menú, Perú\n",
    "------------------------------\n",
    "\n\n\n",
    "\x1D\x56\x00"     // Corte
  ]
};
